import {
  ADD_CATEGORY,
  EDIT_CATEGORY,
  GET_CATEGORIES,
  REMOVE_CATEGORY,
} from '../actions/categories';
import type { ActionWithPayload, ProjectCategory } from '../../types';

export function categoriesReducer(state: Array<ProjectCategory> = [], action: ActionWithPayload): Array<ProjectCategory> {
  switch (action.type) {
    case `${GET_CATEGORIES}_FULFILLED`:
      return action.payload;

    case `${ADD_CATEGORY}_FULFILLED`:
      return [...state, action.payload];

    case `${REMOVE_CATEGORY}_FULFILLED`:
      return state.filter(category => category.id !== action.payload);

    case `${EDIT_CATEGORY}_FULFILLED`:
      return state.map(category => (category.id === action.payload.id ? action.payload : category));

    default:
      return state;
  }
}

export default categoriesReducer;
